import React, { useState, useEffect, useCallback } from "react";
import * as S from "./SimulationsStyle";
import { simulationService } from "../../Services/simulationService";
import { FaSearch, FaCrown, FaDatabase } from "react-icons/fa";

export default function Simulations() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    name: "",
    minAmount: "",
    maxAmount: "",
    startDate: "",
    endDate: "",
  });

  const fetchSimulations = useCallback(
    async (page = 1) => {
      setLoading(true);
      try {
        const response = await simulationService.searchSimulations({
          ...filters,
          page,
          pageSize: 15,
        });
        setData(response.data);
        setTotalCount(response.total);
        setTotalPages(response.totalPages);
        setCurrentPage(response.page);
      } catch (error) {
        console.error("Erro ao buscar simulações:", error);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    },
    [filters]
  );

  useEffect(() => {
    fetchSimulations();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // --- NOVA FUNÇÃO: PESQUISA AO TECLAR ENTER ---
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchSimulations(1);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const RenderSkeleton = () => (
    <>
      {[...Array(8)].map((_, i) => (
        <S.SkeletonRow key={i}>
          <td>
            <S.SkeletonCell width="40px" />
          </td>
          <td>
            <S.SkeletonCell width="180px" />
          </td>
          <td>
            <S.SkeletonCell width="100px" />
          </td>
          <td>
            <S.SkeletonCell width="80px" />
          </td>
          <td>
            <S.SkeletonCell width="60px" />
          </td>
          <td>
            <S.SkeletonCell width="120px" />
          </td>
          <td>
            <S.SkeletonCell width="90px" />
          </td>
        </S.SkeletonRow>
      ))}
    </>
  );

  return (
    <S.Container>
      <S.Header>
        <h1>Histórico de Simulações</h1>
        <p>
          Acompanhe o interesse dos clientes e simulações realizadas na
          plataforma.
        </p>
      </S.Header>

      {/* Adicionado o onKeyDown aqui para capturar o Enter em qualquer campo */}
      <S.FilterSection onKeyDown={handleKeyDown}>
        <S.InputGroup>
          <label>Nome do Cliente</label>
          <input
            name="name"
            placeholder="Ex: João Silva"
            value={filters.name}
            onChange={handleInputChange}
          />
        </S.InputGroup>

        <S.InputGroup>
          <label>Valor Mínimo</label>
          <input
            type="number"
            name="minAmount"
            placeholder="R$ 0,00"
            value={filters.minAmount}
            onChange={handleInputChange}
          />
        </S.InputGroup>

        <S.InputGroup>
          <label>Início</label>
          <input
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleInputChange}
          />
        </S.InputGroup>

        <S.InputGroup>
          <label>Fim</label>
          <input
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleInputChange}
          />
        </S.InputGroup>

        <S.ActionButton onClick={() => fetchSimulations(1)} disabled={loading}>
          <FaSearch /> {loading ? "Buscando..." : "Filtrar"}
        </S.ActionButton>
      </S.FilterSection>

      <S.TableContainer>
        <S.Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Valor Simulado</th>
              <th>Qtd. Contratos</th>
              <th>% Mensal</th>
              <th>Data</th>
              <th>Tipo De Cliente</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <RenderSkeleton />
            ) : data.length > 0 ? (
              data.map((sim) => (
                <tr key={sim.id}>
                  <td>#{sim.id}</td>
                  <td>
                    {sim.client?.name || "Visitante"}
                    {sim.isVipClient && (
                      <FaCrown
                        style={{ color: "#b17d2a", marginLeft: "8px" }}
                        title="VIP"
                      />
                    )}
                  </td>
                  <td>{formatCurrency(sim.amount)}</td>
                  <td>{sim.contractQtt} uni.</td>
                  <td>{sim.monthlyPercentage}%</td>
                  <td>{formatDate(sim.dateCreated)}</td>
                  <td>
                    {sim.isVipClient ? (
                      <S.VipBadge>VIP CLIENT</S.VipBadge>
                    ) : (
                      <span style={{ color: "#666" }}>Padrão</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">
                  <S.EmptyState>
                    <FaDatabase />
                    Nenhuma simulação encontrada com os filtros aplicados.
                  </S.EmptyState>
                </td>
              </tr>
            )}
          </tbody>
        </S.Table>
      </S.TableContainer>

      {!loading && data.length > 0 && (
        <S.Pagination>
          <button
            disabled={currentPage === 1}
            onClick={() => fetchSimulations(currentPage - 1)}
          >
            Anterior
          </button>
          <button className="active">{currentPage}</button>
          <button
            disabled={currentPage === totalPages}
            onClick={() => fetchSimulations(currentPage + 1)}
          >
            Próximo
          </button>
        </S.Pagination>
      )}
    </S.Container>
  );
}
